export default __webpack_public_path__ + "static/media/GIDDY.6f0185b2.png";